import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import api from '../../axiosInstance';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function CreateProductPriceList({ dpid,cid, setcreateProductDetails, editData }) {

    console.log("params", editData);

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        up_id: dpid,
        price: editData?.price || "",
        effected_from: editData?.effected_from || "",
    });

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiUrl = editData?.id
            ? `productpricelist/${editData.id}`
            : "productpricelist";

        const method = editData?.id ? "put" : "post";

        try {
            const response = await api({
                method,
                url: apiUrl,
                data: formData,
            });
            handleClose();
            setcreateProductDetails(response);
            console.log("Success:", response.data);
            Swal.fire({
                icon: "success",
                title: "success",
                text: response.data?.message,
            });

        } catch (error) {
            handleClose();
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response ? error.response.data : error.message || "Something went wrong!",
            });
        }
    };

    return (
        <div>
            {editData?.id ?
                <EditIcon onClick={handleOpen} />
                : <Button onClick={handleOpen} variant="contained">
                    Create Price List
                </Button>}

            <Modal open={open} onClose={handleClose}>
                <Box sx={style}>
                    <Typography variant="h6">Price List</Typography>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-4 col-12 mb-3">
                                <label className="form-label">Price</label>
                                <input
                                    className="form-control"
                                    name="price"
                                    type="number"
                                    value={formData.price}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-4 col-12 mb-3">
                                <label className="form-label">Effective Date</label>
                                <input
                                    className="form-control"
                                    name="effected_from"
                                    type="date"
                                    value={formData.effected_from}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                                <button type="submit" className="btn btn-primary">
                                    {editData?.id ? "Update" : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}
